import { round, sumBy } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { CapitalActionFormValues } from 'routes/LpPages/CapitalActions/AddEditCapitalAction/hooks/useCapitalActionForm';
import aggregateActionsBreakdown from '../../hooks/useAggregateActionsBreakdown';

export default function useActionAllocationsChangeHandler(entryIndex: number) {
  const { setValue, getValues } = useFormContext<CapitalActionFormValues>();

  return (
    actionId: string,
    capitalBreakdown: Array<{
      commitmentId: string;
      amountLcy: number;
      fundsCalled?: {
        fromCommitmentLcy: number;
        fromRecallableDistributionLcy: number;
      };
    }>,
  ) => {
    const currentActions = getValues(`entries.${entryIndex}.actions`);

    if (currentActions.find((action) => action.id === actionId)) {
      return;
    }

    const updatedActions = currentActions.map((action) => {
      return {
        ...action,
        capitalBreakdown:
          action.id === actionId ? capitalBreakdown : action.capitalBreakdown,
      };
    });

    const aggregatedActionsBreakdown =
      aggregateActionsBreakdown(updatedActions);

    setValue(`entries.${entryIndex}.actions`, updatedActions);

    setValue(
      `entries.${entryIndex}.capitalBreakdown`,
      aggregatedActionsBreakdown,
    );

    setValue(
      `entries.${entryIndex}.totalAmount`,
      round(sumBy(aggregatedActionsBreakdown, 'amountLcy'), 2),
    );
  };
}
